import type { SituationCardDetail } from "@peer-start/platform-contracts";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { SituationStatus } from "./SituationStatus.js";

export function SituationCardPageHeading({
  actions,
  card,
  activity = "steady",
}: {
  actions?: ReactNode;
  card: Pick<SituationCardDetail, "title" | "status" | "changedAt">;
  activity?: "steady" | "loading" | "streaming" | "settled";
}) {
  const { t, i18n } = useTranslation();
  const changedLabel = new Intl.DateTimeFormat(i18n.language, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(card.changedAt));
  return (
    <header className="flex shrink-0 items-center justify-between gap-4 bg-background px-4 pt-10 pb-5 lg:px-6">
      <div className="min-w-0">
        <h1 className="text-3xl font-medium tracking-tight text-foreground lg:text-4xl">{card.title}</h1>
        <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1">
          {activity === "loading" ? (
            <p className="text-sm text-muted-foreground" role="status">
              {t("administration.situationCard.generating")}
            </p>
          ) : (
            <SituationStatus status={card.status} />
          )}
          <time className="text-sm text-muted-foreground" dateTime={card.changedAt}>
            {t("administration.situationCard.lastChanged", { date: changedLabel })}
          </time>
        </div>
        {activity === "streaming" || activity === "settled" ? (
          <p className="mt-2 text-sm font-medium text-foreground" role="status">
            {t("administration.situationCard.textUpdated")}
          </p>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </header>
  );
}
